import type { NodeProgress } from '@/api/types'
import { doing } from '@/domain/node'
import { useNow } from '@/hooks/useNow'

// 노드가 지금 하는 일 한 줄 — 노드 상세의 진행 둘째 줄과 노드 카드의 한 줄이 같은 문장을 쓴다.
// 문장은 `domain/node` 의 `doing` 이 짓고 여기는 그 문장의 경과가 흐르게만 한다: 감싸는 글꼴·색은
// 부르는 쪽의 것이라 요소를 더하지 않는다. 컴포넌트가 따로 있는 이유는 1초 틱이 이 문장에만
// 머물게 하는 것이다 — 노드 상세 전체가 1초마다 다시 그려지면 그래프까지 함께 떤다.

export function Doing({ progress }: { progress: NodeProgress }) {
  const now = useNow()
  return <>{doing(progress, now)}</>
}
